let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5DHvE")).then(() => parcelRequire('6nO1v'));